// extracted by mini-css-extract-plugin
export default {"container":"CustomControls_container__-XoEV","button":"CustomControls_button__B32PO"};